import { render, staticRenderFns } from "./OrganizationCardList.vue?vue&type=template&id=ae62aba0&scoped=true&"
import script from "./OrganizationCardList.vue?vue&type=script&lang=js&"
export * from "./OrganizationCardList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationCardList.vue?vue&type=style&index=0&id=ae62aba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae62aba0",
  null
  
)

export default component.exports